import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3684bfaf"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("div", null, "열심히 모아주셨나요?"),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode("수거는 한번만 가능합니다. "),
    /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }),
    /*#__PURE__*/_createTextVNode("수거접수를 도와드릴까요?")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "최대한 많이 보내주세요:)")
], -1))

import { ref, inject, nextTick, reactive } from 'vue';
import { IProgram } from '@/types/program';
import CampaignApply, { Expose as CampaignApplyExpose } from '@/components/campaign/apply.vue';
import CampaignCheck, { Expose as CampaignCheckExpose } from '@/components/campaign/check.vue';
import _ from 'lodash';
import { ColorVariants } from '@/constants';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
interface Props {
  program: IProgram;
}
interface Info {
  title: string;
  content: string;
}


  const __default__ = {
    inheritAttrs: false
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    program: null
  },
  setup(__props: any) {

const props = __props as {
  program: IProgram;
}

dayjs.extend(isBetween);



const dialog = reactive({
  info: false,
  apply: false,
});

const infoDialogProps = ref<Info>();
function showInfoDialog(info: Info) {
  infoDialogProps.value = info;
  showDialog('info');
}

const collectionStartedAt = inject('collection_started_at') as string;
const collectionEndAt = inject('collection_ended_at') as string;
const checkRef = ref<CampaignCheckExpose>();
const refreshPageData = (inject('refreshPageData') || _.noop) as Function;
async function onStart() {
  const valid = await checkRef.value?.check();
  if (valid) {
    await refreshPageData();
    await nextTick();

    const { show_collection_btn, collection_btn_msg, collection_count, limit_collection_count, participation_request_id } = props.program;
    if (show_collection_btn) {
      // 如果limit_collection_count是null 表示不限制次数
      if (limit_collection_count) {
        // 没有次数了显示
        if (collection_count >= limit_collection_count) {
          // 收集请求已经完成。请查看我的页面。
          showInfoDialog({
            title: '',
            content: `이미 수거신청이 완료되었습니다.
  마이페이지에서 확인해주세요.`,
          });
          return;
        }
      }
      startApply();
      return;
    }

    // 不能参与
    const $now = dayjs();
    const $collectionStartedAt = dayjs(collectionStartedAt);
    if ($now.isBefore($collectionStartedAt)) {
      // 这不是收集请求期间。从 6 月 23 日起可以收集。
      showInfoDialog({
        title: '',
        content: `수거신청 기간이 아닙니다.
${$collectionStartedAt.get('month') + 1}월 ${$collectionStartedAt.get('date')}일부터 수거가 가능합니다.`
      });
      return;
    }
    const $collectionEndAt = dayjs(collectionEndAt);
    if ($now.isAfter($collectionEndAt)) {
      // Captain Souk 第 2 季：Pack Changer 活动已经结束。请期待与苏克船长的下一场战役！
      showInfoDialog({
        title: '',
        content: `캡틴쓱 시즌 2 : 팩체인저 캠페인이
종료되었습니다.

캡틴쓱과 함께할 다음 캠페인을 기대해 주세요!`
      });
      return;
    }

    if ($now.isBetween($collectionStartedAt, $collectionEndAt, undefined, '[]')) {
      if (!participation_request_id) {
        // 不接受征收申请。很遗憾，下次回收活动见！
        showInfoDialog({
          title: '',
          content: `수거 신청 대상이 아닙니다.
아쉽지만, 다음 재활용 캠페인에서 만나요!`,
        });
        return;
      }
      if (collection_count) {
        // 收集请求已经完成。请查看我的页面。
        showInfoDialog({
          title: '',
          content: `이미 수거신청이 완료되었습니다.
마이페이지에서 확인해주세요.`,
        });
        return;
      }
    }

    showInfoDialog({
      title: '',
      content: collection_btn_msg!,
    });
  }
}

function startApply() {
  showDialog('apply');
}

const campaignApplyRef = ref<CampaignApplyExpose>();
function apply() {
  closeDialog();
  campaignApplyRef.value?.apply();
}

function showDialog(dialogName: keyof typeof dialog) {
  closeDialog();
  dialog[dialogName] = true;
}

function closeDialog(dialogName?: keyof typeof dialog) {
  if (dialogName) {
    dialog[dialogName] = false;
  } else {
    _.forEach(dialog, (val, key) => {
      if (val) {
        dialog[key] = false;
      }
    });
  }
}

return (_ctx: any,_cache: any) => {
  const _component_AppDialog = _resolveComponent("AppDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(CampaignCheck, {
        ref_key: "checkRef",
        ref: checkRef,
        "class-name": "dialog-campaign-ssg"
      }, null, 512),
      _createVNode(CampaignApply, {
        ref_key: "campaignApplyRef",
        ref: campaignApplyRef,
        "class-name": "dialog-campaign-ssg",
        program: __props.program,
        "apply-success-content": `수거 신청 접수가 완료 됐습니다.

  마이페이지에 입력해 주신 주소로
  3~4일 내 한진택배 기사님이 방문할 예정입니다.`
      }, null, 8, ["program", "apply-success-content"]),
      _createVNode(_component_AppDialog, _mergeProps({
        visible: _unref(dialog).info,
        "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_unref(dialog).info) = $event)),
        class: "dialog-campaign-ssg dialog-campaign-info"
      }, infoDialogProps.value, {
        btns: [
        { text: '확인', style: _unref(ColorVariants).primary, click: () => closeDialog() }
      ]
      }), null, 16, ["visible", "btns"]),
      _createVNode(_component_AppDialog, {
        visible: _unref(dialog).apply,
        "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_unref(dialog).apply) = $event)),
        class: "dialog-campaign-ssg dialog-campaign-apply",
        btns: [
        { text: '아니요', style: _unref(ColorVariants).dark, click: () => closeDialog() },
        { text: '확인', style: _unref(ColorVariants).primary, click: () => apply() }
      ]
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["visible", "btns"])
    ])),
    _createElementVNode("div", {
      class: "trigger",
      onClick: onStart
    }, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 64))
}
}

})